import { CloseRounded } from "@mui/icons-material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import "./css/Modal.scss";
import { Dialog, DialogActions, DialogContent, DialogProps, DialogTitle, IconButton, Typography } from "@mui/material";
import { useStyle } from "./style";
import { LabeledButton } from "@common/LabeledButton/LabeledButton";
import { useDeviceType } from "@hooks/useDeviceType";

interface IParams {
    confirmLabel?: string;
    children: ReactNode;
    displayCancel?: boolean;
    isModalOpen: boolean;
    targetId?: string | number;
    title: string;
    hideActions?: boolean;
    maxWidth?: DialogProps["maxWidth"];
    disableCloseOnBackdropClick?: boolean;
    isAlertModal?: boolean;
    close?(): void;
    confirm?(id?: string | number): void;
}

export const Modal = (props: IParams) => {
    const { t } = useTranslation("common");
    const {
        children,
        isModalOpen,
        displayCancel,
        targetId,
        title,
        hideActions,
        maxWidth,
        disableCloseOnBackdropClick,
        isAlertModal = false,
        close,
        confirm,
        confirmLabel = t("confirm"),
    } = props;

    const { isMobile } = useDeviceType();
    const { classes } = useStyle({ isAlertModal, isMobile });

    const handleClose = (_event: object, reason: string) => {
        if (disableCloseOnBackdropClick && reason === "backdropClick") {
            return;
        }
        close?.();
    };

    return (
        <Dialog
            className={classes.dialog}
            fullWidth
            maxWidth={maxWidth ?? "md"}
            open={isModalOpen}
            onClose={handleClose}
        >
            {close && (
                <IconButton aria-label="close" className="close-button" size="large" onClick={close}>
                    <CloseRounded color="secondary" />
                </IconButton>
            )}
            <DialogTitle className={classes.dialogTitle}>
                <Typography color="secondary" variant="h4">
                    {title}
                </Typography>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>{children}</DialogContent>
            {!hideActions && (
                <DialogActions className={classes.dialogActions}>
                    {displayCancel && (
                        <LabeledButton
                            className="modal_close_button"
                            labelText={t("cancel")}
                            variant="text"
                            onClick={close}
                        >
                            {t("cancel")}
                        </LabeledButton>
                    )}
                    {confirm && (
                        <LabeledButton
                            className="modal_confirm_button"
                            color="primary"
                            labelText={confirmLabel}
                            onClick={() => confirm(targetId)}
                        >
                            {confirmLabel}
                        </LabeledButton>
                    )}
                </DialogActions>
            )}
        </Dialog>
    );
};
